const userEventStatusText = (status) => {
  switch (status) {
    case 0:
      return "Pendente"
    case 1:
      return "Aprovado"
    case 2:
      return "Rejeitado"
    case 3: 
      return "Aprovado Parcialmente"
    default:
      break;
  }
};

export default {
  userEventStatusText,
};
